// Copyright (c) StrangeBee 2023

import AssigneeInfo from '@Molecules/AssigneeInfo/AssigneeInfo';
import { ExtractProps } from '@Molecules/Details/Details';
import { FormatDate } from '@Molecules/Format';
import React, { ReactElement } from 'react';
import { Space } from 'antd';
import { cutString } from '@Helpers/string';

interface ExtractDataProps {
    locale: (...args: any[]) => any;
}

export const extractData = ({ locale }: ExtractDataProps): Record<string, ExtractProps> => ({
    '#computeTitle': {
        name: '',
        render: ({ title, icon }: { title: string; icon: ReactElement }): ReactElement => (
            <div className="result-card__title">
                <Space>
                    {icon}
                    {title}
                </Space>
            </div>
        ),
    },
    '#computeDate': {
        name: '',
        render: ({ date, _createdBy }: { date: number; _createdBy: string }): ReactElement => (
            <div className="result-card__date">
                <FormatDate icon date={date} />
                {_createdBy && <AssigneeInfo assignee={_createdBy} />}
            </div>
        ),
    },
    '#computeDescription': {
        name: '',
        isForce: false,
        render: (description: string): ReactElement => (
            <div className="result-card__description">
                {description === 'N/A' ? locale('common.noDescription') : cutString(description, 140)}
            </div>
        ),
    },
});
